// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customSelect__wrapper .customSelect__control {
  width: 100%;
  border-radius: 0.25rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(58 63 153 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
  font-size: 0.75rem;
  line-height: 1.25;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
          box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  -webkit-transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform;
  transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, -webkit-box-shadow, -webkit-transform;
  -webkit-transition-duration: 300ms;
          transition-duration: 300ms;
  min-height: 28px;
}
.customSelect__wrapper .customSelect__control:hover {
  --tw-border-opacity: 1;
  border-color: rgb(160 174 192 / var(--tw-border-opacity));
}
.customSelect__wrapper .customSelect__control:focus,
.customSelect__wrapper .customSelect__control--menu-is-open {
  --tw-border-opacity: 1;
  border-color: rgb(160 174 192 / var(--tw-border-opacity));
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.customSelect--is-disabled .customSelect__control--is-disabled {
  pointer-events: none;
}
.css-1hwfws3 {
  padding: 0;
}
.customSelect__wrapper .customSelect__indicator-separator {
  display: none;
}
.customSelect__wrapper .customSelect__dropdown-indicator {
  padding: 4px;
}
.customSelect__wrapper .customSelect__option {
  color: #d6d6d6;
  font-size: 14px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.customSelect__wrapper .customSelect__option--is-selected {
  background-color: transparent;
}
.customSelect__wrapper .customSelect__single-value {
  padding-left: 0.25rem;
  --tw-text-opacity: 1;
  color: rgb(123 178 206 / var(--tw-text-opacity));
  max-width: calc(100% - 20px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.customSelect__wrapper.customSelect--is-disabled {
  pointer-events: auto;
  cursor: not-allowed;
}
.customSelect__wrapper .customSelect__value-container--is-multi {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.ohif-select .customSelect__menu {
  background-color: transparent !important;
  border-radius: 6px;
}
.ohif-select .customSelect__menu-list {
  overflow-x: hidden !important;
  margin: 4px;
  padding-top: 0px !important;
}
.ohif-select .customSelect__menu-list::-webkit-scrollbar {
  width: 6px;
  border-radius: 10px;
}
.ohif-select .customSelect__placeholder {
  padding-left: 0.375rem;
  --tw-text-opacity: 1;
  color: rgb(123 178 206 / var(--tw-text-opacity));
}
.ohif-select .customSelect__menu-list::-webkit-scrollbar-thumb {
  background-color: #0944b3;
  border-radius: 10px;
}
.customSelect__option--is-focused {
  background-color: #0944b391 !important;
}
.ohif-select .customSelect__option:hover {
  background-color: #0944b391;
}
.ohif-select .customSelect__menu {
  border: 2px solid #0944b3;
  border-radius: 6px;
  background-color: #151515 !important;
}
.css-1hwfws3 {
  all: unset !important;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/Select/Select.css"],"names":[],"mappings":"AACE;EAAA,WAA4H;EAA5H,sBAA4H;EAA5H,iBAA4H;EAA5H,sBAA4H;EAA5H,uDAA4H;EAA5H,kBAA4H;EAA5H,mDAA4H;EAA5H,kBAA4H;EAA5H,iBAA4H;EAA5H,oBAA4H;EAA5H,gDAA4H;EAA5H,4EAA4H;EAA5H,2FAA4H;EAA5H,+GAA4H;UAA5H,uGAA4H;EAA5H,gIAA4H;EAA5H,wHAA4H;EAA5H,wGAA4H;EAA5H,+IAA4H;EAA5H,kCAA4H;UAA5H,0BAA4H;EAC5H;AAD4H;AAI5H;EAAA,sBAAsB;EAAtB;AAAsB;AAKtB;;EAAA,sBAAmC;EAAnC,yDAAmC;EAAnC,8BAAmC;EAAnC;AAAmC;AAInC;EAAA;AAA0B;AAG5B;EACE,UAAU;AACZ;AAGE;EAAA;AAAa;AAGf;EACE,YAAY;AACd;AAEA;EACE,cAAc;EACd,eAAe;EAGf,oBAAiC;EAAjC,oBAAiC;EAAjC,aAAiC;EAAjC,8BAAiC;EAAjC,6BAAiC;MAAjC,uBAAiC;UAAjC,mBAAiC;EAAjC,yBAAiC;MAAjC,sBAAiC;UAAjC,mBAAiC;AACnC;AAGE;EAAA;AAAqB;AAIrB;EAAA,qBAA0B;EAA1B,oBAA0B;EAA1B,gDAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB;AAJ0B;AAQ1B;EAAA,oBAA6C;EAA7C;AAA6C;AAI7C;EAAA,qBAAsC;EAAtC,gBAAsC;EAAtC,uBAAsC;EAAtC,mBAAsC;EAAtC,qBAAsC;EAAtC,sBAAsC;EAAtC,mBAAsC;EAAtC;AAAsC;AAGxC;EACE,wCAAwC;EACxC,kBAAkB;AACpB;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,2BAA2B;AAC7B;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;AAEE;EAAA,sBAA4B;EAA5B,oBAA4B;EAA5B;AAA4B;AAG9B;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AAEA;EACE,sCAAsC;AACxC;AAEA;EACE,2BAA2B;AAC7B;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".customSelect__wrapper .customSelect__control {\n  @apply border-secondary-light w-full rounded border bg-black text-sm leading-tight text-white shadow transition duration-300;\n  min-height: 28px;\n}\n.customSelect__wrapper .customSelect__control:hover {\n  @apply border-gray-500;\n}\n\n.customSelect__wrapper .customSelect__control:focus,\n.customSelect__wrapper .customSelect__control--menu-is-open {\n  @apply border-gray-500 outline-none;\n}\n\n.customSelect--is-disabled .customSelect__control--is-disabled {\n  @apply pointer-events-none;\n}\n\n.css-1hwfws3 {\n  padding: 0;\n}\n\n.customSelect__wrapper .customSelect__indicator-separator {\n  @apply hidden;\n}\n\n.customSelect__wrapper .customSelect__dropdown-indicator {\n  padding: 4px;\n}\n\n.customSelect__wrapper .customSelect__option {\n  color: #d6d6d6;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  @apply flex flex-row items-center;\n}\n\n.customSelect__wrapper .customSelect__option--is-selected {\n  @apply bg-transparent;\n}\n\n.customSelect__wrapper .customSelect__single-value {\n  @apply text-aqua-pale pl-1;\n  max-width: calc(100% - 20px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.customSelect__wrapper.customSelect--is-disabled {\n  @apply pointer-events-auto cursor-not-allowed;\n}\n\n.customSelect__wrapper .customSelect__value-container--is-multi {\n  @apply inline-block truncate px-3 py-2;\n}\n\n.ohif-select .customSelect__menu {\n  background-color: transparent !important;\n  border-radius: 6px;\n}\n\n.ohif-select .customSelect__menu-list {\n  overflow-x: hidden !important;\n  margin: 4px;\n  padding-top: 0px !important;\n}\n\n.ohif-select .customSelect__menu-list::-webkit-scrollbar {\n  width: 6px;\n  border-radius: 10px;\n}\n.ohif-select .customSelect__placeholder {\n  @apply text-aqua-pale pl-1.5;\n}\n\n.ohif-select .customSelect__menu-list::-webkit-scrollbar-thumb {\n  background-color: #0944b3;\n  border-radius: 10px;\n}\n\n.customSelect__option--is-focused {\n  background-color: #0944b391 !important;\n}\n\n.ohif-select .customSelect__option:hover {\n  background-color: #0944b391;\n}\n\n.ohif-select .customSelect__menu {\n  border: 2px solid #0944b3;\n  border-radius: 6px;\n  background-color: #151515 !important;\n}\n\n.css-1hwfws3 {\n  all: unset !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
